import { History, Menu, RefreshCw, Trophy } from 'lucide-react';
import { useAppTheme } from '../hooks/useAppTheme';
import { useT } from '../hooks/useT';

interface NavbarProps {
  onOpenMenu: () => void;
  onOpenHistory: () => void;
  onOpenStats: () => void;
  onNewGame: () => void;
  isInGame: boolean;
}

const iconButton =
  'flex h-11 min-w-11 items-center justify-center gap-1.5 rounded-2xl px-3 text-sm font-semibold whitespace-nowrap transition-all duration-150 active:scale-95';

export function Navbar({ onOpenMenu, onOpenHistory, onOpenStats, onNewGame, isInGame }: NavbarProps) {
  const { t } = useT();
  const { theme } = useAppTheme();

  return (
    <header className={`sticky top-0 z-30 ${theme.navBg} px-4 py-2 backdrop-blur-xl sm:px-6`}>
      <div className="mx-auto flex max-w-4xl items-center justify-between gap-3">
        {/* Merk: dartbord + woordmerk als tekst, zodat het meekleurt met licht en donker */}
        <div className="flex min-w-0 items-center gap-2">
          <img src="/Images/dartboard-120.png" alt="" aria-hidden width={40} height={40} className="h-9 w-9 shrink-0 sm:h-10 sm:w-10" />
          {/* Tijdens een partij is er op smalle schermen alleen ruimte voor het dartbord naast de knoppen */}
          <span
            className={`truncate text-xl font-extrabold tracking-tight italic sm:text-2xl ${isInGame ? 'sr-only sm:not-sr-only' : ''}`}
            aria-label={t('logoAlt')}
          >
            <span className="text-slate-900 dark:text-slate-50">DART</span>
            <span className="text-amber-700 dark:text-amber-400">MASTER</span>
          </span>
        </div>

        <nav className="flex items-center gap-2">
          {isInGame && (
            <button onClick={onNewGame} aria-label={t('navNewGame')} className={`${iconButton} ${theme.navButtonBg} ${theme.navButtonText}`}>
              <RefreshCw size={18} aria-hidden />
            </button>
          )}
          <button onClick={onOpenHistory} aria-label={t('navHistory')} className={`${iconButton} ${theme.navButtonBg} ${theme.navButtonText}`}>
            <History size={18} className={theme.navIconColor} aria-hidden />
            <span className="hidden md:inline">{t('navHistory')}</span>
          </button>
          <button
            onClick={onOpenStats}
            aria-label={t('navStats')}
            className={`${iconButton} bg-amber-500/15 text-amber-900 hover:bg-amber-500/25 dark:text-amber-200`}
          >
            <Trophy size={18} aria-hidden />
            <span className="hidden md:inline">{t('navStats')}</span>
          </button>
          <button
            onClick={onOpenMenu}
            aria-label={t('menuOpen')}
            aria-haspopup="dialog"
            className={`${iconButton} ${theme.badgeBg} ${theme.badgeText}`}
          >
            <Menu size={20} aria-hidden />
          </button>
        </nav>
      </div>
    </header>
  );
}
